import React from "react";
import { Text } from "@react-pdf/renderer";

export const Copyright = ({ children }) => <><Text>&copy;</Text> {children}</>;
